<template>
  <section :id="id" class="st-section" :aria-labelledby="id + '-h'" tabindex="-1">
    <!-- шапка раздела: тёмный заголовок + количество, справа «Смотреть все»
         на одной линии с заголовком, под ними короткий подзаголовок -->
    <div class="st-section__head">
      <div class="st-section__title">
        <h2 :id="id + '-h'" class="st-heading">{{ title }}</h2>
        <span class="st-section__count" :aria-label="total + ' ' + plural(total)">{{
          total
        }}</span>
      </div>
      <RouterLink class="st-link-all" :to="allTo"
        ><span class="st-link-all__long">Смотреть все</span
        ><span class="st-link-all__short">Все</span> <ArrowIcon
      /></RouterLink>
      <p v-if="sub" class="st-section__sub">{{ sub }}</p>
    </div>

    <CatalogFilter
      v-if="combos"
      :combos="combos"
      :label="'Фильтр: ' + title"
      @change="onFilter"
    />

    <div v-if="loadingFilter && !items.length" class="st-empty">
      <ui-loading-page />
    </div>

    <div v-else-if="!items.length" class="st-empty">
      По заданным условиям ничего не найдено
    </div>

    <div v-else class="st-grid" :class="loadingFilter && 'st-grid--loading'">
      <ProductCard
        v-for="item in items"
        :key="item.id"
        :item="item"
        :applying="applyingId === item.id"
        @apply="$emit('apply', $event)"
        @error="$emit('error', $event)"
      />
    </div>

    <div v-if="items.length && total > items.length" class="st-more">
      <ui-button
        class="st-btn st-btn--ghost"
        :loading="loadingPage"
        @click="loadMore"
        >Загрузить ещё</ui-button
      >
    </div>
  </section>
</template>

<script>
import { getCatalog } from "@/views/catalog/api";
import ArrowIcon from "./ArrowIcon.vue";
import CatalogFilter from "./CatalogFilter.vue";
import ProductCard from "./ProductCard.vue";

// размер страницы подборки (кнопка «Загрузить ещё»), как в каталоге
const PAGE_SIZE = 6;

export default {
  name: "CatalogSection",
  components: { ArrowIcon, CatalogFilter, ProductCard },
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    sub: String,
    // куда ведёт «Смотреть все»: каталог, для техники — сразу на нужной вкладке
    allTo: { type: [String, Object], default: "/catalog" },
    // условия подборки для API: { type: 'new' | 'used' } либо { special: true }
    query: { type: Object, required: true },
    // первая страница из getCatalogHome: { total, data }
    initial: { type: Object, required: true },
    // сочетания для фильтра раздела; без них фильтр не показывается
    combos: { type: Array, default: null },
    // позиция, по которой сейчас оформляется заявка
    applyingId: { type: Number, default: null },
  },
  emits: ["apply", "error"],
  data() {
    return {
      items: this.initial.data || [],
      total: this.initial.total || 0,
      rows: [],
      loadingPage: false,
      loadingFilter: false,
      // защита от гонки ответов при быстрой смене фильтра
      requestToken: 0,
    };
  },
  methods: {
    plural(count) {
      const mod10 = count % 10;
      const mod100 = count % 100;
      if (mod10 === 1 && mod100 !== 11) return "предложение";
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return "предложения";
      return "предложений";
    },
    async onFilter(rows) {
      this.rows = rows;
      const token = ++this.requestToken;
      this.loadingFilter = true;
      try {
        const response = await getCatalog({
          ...this.query,
          rows,
          limit: PAGE_SIZE,
          offset: 0,
        });
        if (token !== this.requestToken) return;
        if (response.status) {
          this.items = response.data;
          this.total = response.total;
        }
      } catch (e) {
        if (token === this.requestToken) {
          this.$emit("error", "Не удалось загрузить подборку. Попробуйте позже.");
        }
      } finally {
        if (token === this.requestToken) this.loadingFilter = false;
      }
    },
    // «Загрузить ещё»: расширяется только этот раздел, без прокрутки страницы
    async loadMore() {
      const token = this.requestToken;
      this.loadingPage = true;
      try {
        const response = await getCatalog({
          ...this.query,
          rows: this.rows,
          limit: PAGE_SIZE,
          offset: this.items.length,
        });
        // фильтр сменился, пока догружали — страница уже не относится к выдаче
        if (token !== this.requestToken) return;
        if (response.status) {
          const known = new Set(this.items.map((item) => item.id));
          this.items = [
            ...this.items,
            ...response.data.filter((item) => !known.has(item.id)),
          ];
          this.total = response.total;
        }
      } catch (e) {
        this.$emit("error", "Не удалось загрузить предложения. Попробуйте позже.");
      } finally {
        this.loadingPage = false;
      }
    },
  },
};
</script>
